import { TurbineStatus } from './TurbineStatus';

export const TurbineStatusCount = ({ byStatus, status }) => {
    const turbines = byStatus[status];

    const size = turbines?.length || 0;

    return <TurbineStatus data-testid={`turbine-status-${status}`} status={status} value={size} width="fit-content" />;
};
